var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box13-page"},[_c('pageTitle',{attrs:{"title":'常见问题',"tit":''}}),_c('commonProblem',{attrs:{"problemData":_vm.problemData,"titleLeftHover":_vm.titleLeftHover,"styleData":_vm.styleData,"pageName":_vm.pageName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }